(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-featured-new"] && !Shopify.designMode) return;
  try {
    
  // Keeping product + gift pairs together in the cart (sync, links, checkout lock) lives in assets/global.js.
  // This section only shows the product and adds it to the cart with its gift.

  function cartEndpoint(action) {
    const routes = window.routes || {};
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${routes[`cart_${action}_url`] || `${root}cart/${action}`}.js`;
  }

  async function postCart(action, body) {
    const response = await fetch(cartEndpoint(action), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    return response.json();
  }

  function emit(eventName, data) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS[eventName], data);
  }

  class FeaturedNewProduct extends HTMLElement {
    connectedCallback() {
      if (this.config) return;
      try {
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      } catch (error) {
        return;
      }

      this.variants = this.config.variants || [];
      this.currentVariant = this.variants.find((variant) => variant.id === this.config.initialVariantId);
      this.form = this.querySelector('form[data-type="featured-new-form"]');
      this.button = this.querySelector('[data-add-button]');
      this.errorMessage = this.querySelector('[data-error]');

      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));

      this.updateOptionStates();
    }

    onChange(event) {
      if (event.target.matches('[data-option-index]')) {
        this.onOptionChange();
      } else if (event.target.matches('[data-quantity-input]')) {
        event.target.value = this.getQuantity();
      }
    }

    onClick(event) {
      const thumb = event.target.closest('[data-thumb]');
      if (thumb) {
        this.showMedia(thumb.dataset.thumb);
        return;
      }

      const step = event.target.closest('[data-qty-step]');
      if (step) {
        const input = this.querySelector('[data-quantity-input]');
        if (input) input.value = Math.max(1, this.getQuantity() + Number(step.dataset.qtyStep));
      }
    }

    onSubmit(event) {
      event.preventDefault();
      this.addToCart();
    }

    getSelectedOptions() {
      const selected = [];
      this.querySelectorAll('[data-option-index]').forEach((field) => {
        if (field.type === 'radio' && !field.checked) return;
        selected[Number(field.dataset.optionIndex)] = field.value;
      });
      return selected;
    }

    getQuantity() {
      const input = this.querySelector('[data-quantity-input]');
      return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
    }

    onOptionChange() {
      const selected = this.getSelectedOptions();
      const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));

      this.currentVariant = variant;
      this.showError();
      this.updateOptionStates();

      const idInput = this.form && this.form.querySelector('[name="id"]');
      if (idInput && variant) idInput.value = variant.id;
      if (variant && variant.mediaId) this.showMedia(variant.mediaId);

      this.updatePrice(variant);
      this.updateButton(variant);
    }

    // Marks option values that can't be bought together with the rest of the current selection.
    updateOptionStates() {
      const selected = this.getSelectedOptions();
      this.querySelectorAll('[data-option-index]').forEach((field) => {
        const index = Number(field.dataset.optionIndex);
        const choices = field.tagName === 'SELECT' ? Array.from(field.options) : [field];
        choices.forEach((choice) => {
          const isAvailable = this.variants.some(
            (variant) =>
              variant.available &&
              variant.options.every((value, i) => (i === index ? value === choice.value : value === selected[i]))
          );
          if (field.tagName === 'SELECT') {
            choice.textContent = isAvailable ? choice.value : `${choice.value} - ${this.dataset.labelUnavailable}`;
          } else {
            choice.toggleAttribute('data-unavailable', !isAvailable);
          }
        });
      });
    }

    updatePrice(variant) {
      const price = this.querySelector('[data-price]');
      if (!price) return;

      price.hidden = !variant;
      if (!variant) return;

      price.querySelector('[data-price-current]').innerHTML = variant.price;
      price.querySelector('[data-price-compare]').innerHTML = variant.compareAtPrice || '';
      price.querySelector('[data-price-compare-wrap]').hidden = !variant.compareAtPrice;
      price.querySelector('[data-badge-sale]').hidden = !variant.compareAtPrice || !variant.available;
      price.querySelector('[data-badge-sold-out]').hidden = variant.available;
    }

    updateButton(variant) {
      if (!this.button) return;
      const label = this.button.querySelector('[data-add-label]');

      if (!variant) {
        label.textContent = this.dataset.labelUnavailable;
      } else if (!variant.available) {
        label.textContent = this.dataset.labelSoldOut;
      } else {
        label.textContent = this.button.dataset.labelAdd;
      }
      this.button.disabled = !variant || !variant.available;
    }

    showMedia(mediaId) {
      const id = String(mediaId);
      const slides = this.querySelectorAll('[data-media-id]');
      if (!Array.from(slides).some((slide) => slide.dataset.mediaId === id)) return;

      slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.mediaId === id));
      this.querySelectorAll('[data-thumb]').forEach((thumb) => {
        thumb.setAttribute('aria-current', String(thumb.dataset.thumb === id));
      });
    }

    setBusy(isBusy) {
      this.busy = isBusy;
      if (!this.button) return;
      this.button.classList.toggle('is-loading', isBusy);
      this.button.setAttribute('aria-busy', String(isBusy));
      if (isBusy) {
        this.button.setAttribute('aria-disabled', 'true');
      } else {
        this.button.removeAttribute('aria-disabled');
      }
    }

    showError(message) {
      if (!this.errorMessage) return;
      this.errorMessage.textContent = message || '';
      this.errorMessage.hidden = !message;
    }

    async addToCart() {
      const variant = this.currentVariant;
      if (this.busy || !variant || !variant.available) return;

      const quantity = this.getQuantity();
      const { name, value } = this.config.attribute || {};
      const properties = name && value ? { [name]: value } : {};
      const gift = this.config.gift;
      let items = [{ id: variant.id, quantity, properties }];

      if (gift && gift.variantId !== variant.id) {
        // The pair id marks both lines so assets/global.js can keep them together in the cart.
        const pairProperties = window.featuredGiftCart
          ? window.featuredGiftCart.bundleProperties(variant.id, gift.variantId)
          : {};
        const linked = { ...properties, ...pairProperties };
        // Shopify puts each new line at the top of the cart, so the gift goes first to sit under the product.
        items = [
          { id: gift.variantId, quantity, properties: linked },
          { id: variant.id, quantity, properties: linked },
        ];
      }

      const drawer = document.querySelector('cart-drawer');
      const canRenderDrawer = drawer && typeof drawer.renderContents === 'function';
      const body = { items };
      if (canRenderDrawer) {
        body.sections = drawer.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(this.button);
      }

      this.setBusy(true);
      this.showError();

      try {
        const state = await postCart('add', body);

        if (state.status) {
          emit('cartError', {
            source: 'featured-new',
            productVariantId: variant.id,
            errors: state.errors || state.description,
            message: state.message,
          });
          this.showError(state.description || state.message);
          return;
        }

        if (!canRenderDrawer) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        emit('cartUpdate', { source: 'featured-new', productVariantId: variant.id, cartData: state });
        drawer.classList.remove('is-empty');
        try {
          drawer.renderContents(state);
        } catch (error) {
          console.error(error);
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (error) {
        console.error(error);
        this.showError(window.cartStrings && window.cartStrings.error);
      } finally {
        this.setBusy(false);
      }
    }
  }

  if (!customElements.get('featured-new-product')) customElements.define('featured-new-product', FeaturedNewProduct);

  } catch(e) { console.error(e); }
})();
})();
